module.exports = __webpack_public_path__ + "img/7_203.c98df3db.png";